<template>
    <div class="all">
        <div class="page-right w250 temp-right fr" v-if="!isPreview">
            <vue-scroll :ops="ops"  style="width:250px;height:100%">
                <div class="type-list">
                    <div class="type-top">
                        <h2 class=""><span class="switch" :class="status == 1 ? 'active' : ''" @click="oneButtonSwitch();">红头文件 <i class="icons switch-icon fr"></i></span></h2>
                    </div>
                    <div class="type-header">
                        <h2 class="title">选择模块</h2>
                    </div>
                    <draggable :list="list2" :options="{group:{name: falgs,pull:'clone'}, sort: false}" @end="end" class="dragArea">
                        <div v-for="element in list2" :key="element.id" class="list-complete-item text">
                            <i class="icons" :class="element.icon" v-show="element.type !== 1"></i>
                            <i class="iconfont" :class="element.icon" v-show="element.type === 1"></i>
                            {{element.name}}
                        </div>
                    </draggable>
                </div>
            </vue-scroll>

        </div>
        <div class="page-left pr260" v-if="!isPreview">
            <div class="detail-warp">
				<button class="btn btn-blue mb30" @click="$router.go(-1)">返回列表</button>
                <div class="redHeader mb30" :class="status == 1 ? '' : 'hide'">
                    <input class="template-title ac db color-red" type="text" placeholder="填写红头文件标题" v-model="tempform.redFileTit"/>
                    <input class="template-author ac db" type="text" placeholder="填写红头文件编号" v-model="tempform.redFileName"/>
                    <img src="https://bsddata.oss-cn-hangzhou.aliyuncs.com/yuqing_oem/html/red_line.png"/>
                </div>
                <input class="template-title ac db" type="text" placeholder="填写报告标题" v-model="tempform.tit"/>
                <input class="template-author ac db" type="text" placeholder="填写作者名称" v-model="tempform.name"/>
                <div class="dragWrap">
                    <draggable :list="list1" :options="{group:'article', disabled: disabled}" @start="start22" @end="end22" class="dragArea11">
                        <div v-for="(element, index) in list1" :key="index">
                            <div class="tit">
                                <i class="icons del-sm-icon mt5 fr" @click="handleDel(index, element.id,element.chartId)"></i>
                                <div class="tnumber">{{index+1<9?'0'+(index+1):index+1}}</div>
                                <input class="name" type="text" v-model="element.name"/>
                                <span class="drop-down mores ml20" v-if="element.showCity">
                                    <button class="btn btn-lightblue"><span class="text">{{element.curCity}}</span><i class="icons"></i></button>
                                    <ul class="option">
                                        <li class="repTem" v-for="(item, ind) in cityList" :key="ind" @click="choseCity(item.name,index,ind)">{{item.name}}</li>
                                    </ul>
                                </span>
                            </div>
                            <div class="cont ac mt15">
                                <img :src="element.img" v-if="element.img != ''"/>
                                <textarea type="text" v-if="element.isText" class="input-textarea"  v-model="element.text"></textarea>
                            </div>
                        </div>
                    </draggable>
                </div>
                <div class="bottom ac mt20">
                    <button class="btn save btn-jbblue" :class="{ 'disabled': isActive==true }" @click="saveTemplete">保存模板</button>
                    <button class="btn save btn-jbblue ml20" @click="previewOpen" v-show="!isShow">预览模板</button>
                    <button class="btn save btn-none ml20" @click="previewBack" v-show="isShow">返回</button>
                </div>
            </div>
        </div>
        <div class="page-left" v-if="isPreview">
            <div class="detail-warp">
				<button class="btn btn-blue" @click="$router.go(-1)">返回列表</button>
                <div class="redHeader mb30" :class="status == 1 ? '' : 'hide'">
                    <div class="fs28 ac db color-red">{{tempform.redFileTit}}</div>
                    <p class="fs24 ac db mb10">{{tempform.redFileName}}</p>
                    <img src="https://bsddata.oss-cn-hangzhou.aliyuncs.com/yuqing_oem/html/red_line.png"/>
                </div>
                <div class="fs24 ac db">{{tempform.tit}}</div>
                <div class="mt20 ac db">{{tempform.name}}</div>
                <div class="dragWrap mt20">
                    <div class="dragArea11">
                        <div v-for="(element, index) in list1" :key="index">
                            <div class="d-flex">
                                <div class="tnumber">{{index+1<9?'0'+(index+1):index+1}}</div>
                                <div class="tit fs16 flex1">{{element.name}}</div>
                            </div>
                            <div class="cont ac mt15">
                                <p class="al" v-if="element.info!=undefined">{{element.info}}</p>
                                <img :src="element.img" v-if="element.img != ''"/>
                                <div v-if="element.isText" class="al">{{element.text}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    components:{
        draggable
    },
    data() {
        return {
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            sid:this.$route.query.id,
            isPreview:this.$route.query.isPreview,
            isFromTiming:this.$route.query.fromTiming,
            status:0,//红头文件显示状态
            tempform:{},
            falgs: 'article',
            disabled: false,
            list:[],
            list1: [],
            list2: [
                {id: 1,moduleType:'文本', isChart:false,name:'文本',icon:'text-icon',img:'',isText:true,text:'',chartId:'customText'},
                {id: 2,moduleType:'报告简述', isChart:false, name: '报告简述',icon:'text-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/bgjs.jpg',text:'',chartId:'summary'},
                {id: 3,moduleType:'监测方案', isChart:false, name: '监测方案',icon:'text-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/jcfa.jpg',chartId:'overview'},
                {id: 4,moduleType:'折线图',isChart:true, name:'事件走势',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/sjzs.jpg',chartId:'reportTrend',info:'据下图可知，2017年04月08日 00:00至2017年04月14日 23:59，微信信息xxx条，占比xx%；网页信息xxx条，占比xx%；微博舆情xxx条，占比xx%；论坛舆情信息xxx条，占比xx%；报刊信息xxx条，占比（3.67%）；舆情信息xxx条，占比xx%。'},
                {id: 5,moduleType:'横向柱状榜单',isChart:true, name:'分析词榜单',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/fxcbd.jpg',chartId:'analyseWord'},
				        {id: 6,moduleType:'首发媒体',isChart:false, name:'首发媒体',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/sf.jpg',chartId:'firstMedia'},
				        {id: 7,moduleType:'文章TOP',isChart:false, name:'热门文章TOP',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/hottop.jpg',chartId:'hotArticle'},
                // {id: 8,moduleType:'竞品文章TOP',isChart:false, name:'竞品热门文章',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/jptop.png',chartId:'competeHotArticle'},
                // {id: 9,moduleType:'竞品文章TOP',isChart:false, name:'行业热门文章TOP',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/hytop.png',chartId:'industryHotArticle'},
                {id: 10,moduleType:'文章TOP',isChart:false, name:'负面文章TOP',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/hottop.jpg',chartId:'negArticle'},
                // {id: 11,moduleType:'竞品文章TOP',isChart:false, name:'竞品负面文章TOP',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/jptop.png',chartId:'competeNegArticle'},
                // {id: 12,moduleType:'竞品文章TOP',isChart:false, name:'行业负面文章TOP',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/hytop.png',chartId:'industryNegArticle'},
                {id: 13,moduleType:'饼状图',isChart:true, name:'情绪分布',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/qxpei.jpg',chartId:'moodDist',info:'据下图可知，2019年08月08日 00:00:00至2019年08月14日 23:59:59，舆情信息中喜悦xxx条，占比xx%、赞扬xxx条，占比xx%、愤怒xxx条，占比xx%、悲伤xxx条，占比xx%、恐惧xxx条，占比xx%、厌恶xxx条，占比xx%、惊奇xxx条，占比xx%。'},
                {id: 14,moduleType:'折线图',isChart:true, name:'情感属性',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/qgsx.jpg',chartId:'emotionDistLine',info:'据下图可知，2019年08月08日 00:00:00至2019年08月14日 23:59:59，正面舆情信息xxx条，占比xx%；负面舆情信息xxx条，占比xx%；中性舆情信息xxx条，占比xx%。'},
                {id: 36,moduleType:'饼状图',isChart:true, name:'情感属性占比',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/qgsxzb.png',chartId:'emotionDistPie',info:'据下图可知，2019年08月08日 00:00:00至2019年08月14日 23:59:59，正面舆情信息xxx条，占比xx%；负面舆情信息xxx条，占比xx%；中性舆情信息xxx条，占比xx%。'},
                {id: 15,moduleType:'饼状图',isChart:true, name:'媒体分布',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/mtfb.jpg',chartId:'mediaDist',info:'据下图可知，2017年04月08日 00:00至2017年04月14日 23:59，微信信息xxx条，占比xx%；网页信息xxx条，占比xx%；微博舆情xxx条，占比xx%；论坛舆情信息xxx条，占比xx%；报刊信息xxx条，占比xx%；舆情信息xxx条，占比xx%。'},
                {id: 16,moduleType:'饼状图',isChart:true, name:'平台分布占比',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/ptfbzb.jpg',chartId:'platformDistPie'},
                {id: 17,moduleType:'柱状图',isChart:true, name:'平台分布',icon:'data2-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/ptfb.jpg',chartId:'platformDistColumn'},
                {id: 18,moduleType:'活跃渠道',isChart:false, name:'活跃渠道',icon:'menu-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/hyqd.jpg',chartId:'activeChannel'},
                {id: 20,moduleType:'活跃渠道',isChart:false, name:'敏感信息报道渠道',icon:'menu-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/hyqd.jpg',chartId:'sensitiveChannel'},
                {id: 21,moduleType:'影响力渠道',isChart:false, name:'影响力渠道',icon:'menu-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/yxlqd.jpg',chartId:'impactChannel'},
                {id: 22,moduleType:'饼状图',isChart:true, name:'账号认证',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/zhrz.png',chartId:'accountAuth'},
                {id: 23,moduleType:'嵌套饼状图',isChart:true, name:'传播力分析',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/chuanbofx.png',chartId:'spreadDist'},
                {id: 24,moduleType:'饼状图',isChart:true,name:'文章类型',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/wzlx.png',chartId:'articleType'},
                {id: 25,moduleType:'词云图',isChart:true, name:'热门词云',icon:'yun-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/worldcloud.png',chartId:'wordCloud',info:'2019年08月08日 00:00:00至2019年08月14日 23:59:59，xxx一词出现频率最高，达xxx，其次是xxx，出现次数达xxx次。'},
                {id: 26,moduleType:'饼状图',isChart:true, name:'热门词云占比',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/peiworld.png',chartId:'wordCloudPie'},
                {id: 27,moduleType:'雷达图',isChart:true, name:'热门词云雷达',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/worldleida.png',chartId:'wordCloudRadar'},
                {id: 28,moduleType:'地图',isChart:true, name:'发布地区',icon:'map-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/map.png',chartId:'pubArea',showCity:true,province:'全国',numId:0,maxId:0,info:'据下图显示，发布信息地域前十有北京、广东、上海、浙江、山东、四川、山西、河南、河北、安徽，其中北京舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；上海舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；山东舆情信息有xxx条，占比xx%；四川舆情信息有xxx条，占比xx%；山西舆情信息有xxx条，占比xx%；河南舆情信息有xxx条，占比xx%；河北舆情信息有xxx条，占比xx%；安徽舆情信息有xxx条，占比xx%。'},
                {id: 29,moduleType:'地图',isChart:true, name:'提及地区',icon:'map-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/map.png',chartId:'refArea',showCity:true,province:'全国',numId:0,maxId:0,info:'据下图显示，信息提及地域前十有北京、广东、上海、浙江、山东、四川、山西、河南、河北、安徽，其中北京舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；上海舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；山东舆情信息有xxx条，占比xx%；四川舆情信息有xxx条，占比xx%；山西舆情信息有xxx条，占比xx%；河南舆情信息有xxx条，占比xx%；河北舆情信息有xxx条，占比xx%；安徽舆情信息有xxx条，占比xx%。'},
                {id: 30,moduleType:'横向柱状图',isChart:true, name:'网民观点',icon:'data2-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/wmgd.jpg',chartId:'netizenView'},
                {id: 31,moduleType:'媒体观点',isChart:false, name:'媒体观点',icon:'icon-wangminguandian',type:1,img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/mtgd.jpg',chartId:'mediaView'},
                {id: 32,moduleType:'预警趋势图',isChart:true, name:'预警趋势',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/yujingqushi.jpg',chartId:'warningTrend'},
                // {id: 33,moduleType:'TWO首发媒体',isChart:false, name:'竞品首发媒体',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/jpsf.jpg',chartId:'competeFirstMedia'},
                // {id: 34,moduleType:'TWO首发媒体',isChart:false, name:'行业首发媒体',icon:'data1-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/jphy.jpg',chartId:'industryFirstMedia'},
                {id: 33,moduleType:'处置建议',isChart:false, name:'处置建议',icon:'text-icon',img:'',isText:true,text:'对于舆情信息中具有潜在危害的事件及情况应给予关注并积极处理，防止不良影响产生及扩散。此外，密切关注此前敏感预警事件的发展情况，及时制定有效应对措施。鉴于分析结果中负面舆情时有发生， 应吸取相关经验教训，做好预防和处理工作。',chartId:'suggestion'},
				        {id: 34,moduleType:'重点文章列表',isChart:false, name:'重点文章列表',icon:'icon-wangminguandian',type:1,img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/zdwzlb.jpg',chartId:'importantArticle'},
                {id: 35,moduleType:'地图',isChart:true, name:'IP属地',icon:'map-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/map.png',chartId:'ipArea',province:'全国',numId:0,maxId:0,info:'据下图显示，信息提及地域前十有北京、广东、上海、浙江、山东、四川、山西、河南、河北、安徽，其中北京舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；上海舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；山东舆情信息有xxx条，占比xx%；四川舆情信息有xxx条，占比xx%；山西舆情信息有xxx条，占比xx%；河南舆情信息有xxx条，占比xx%；河北舆情信息有xxx条，占比xx%；安徽舆情信息有xxx条，占比xx%。'},
                {id: 40,moduleType:'饼状图',isChart:true, name:'IP属地占比',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/ptfbzb.jpg',chartId:'ipPie'},
                {id: 37,moduleType:'饼状图',isChart:true, name:'媒体类别占比',icon:'ring-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/ptfbzb.jpg',chartId:'mediaLevelPie'},
                {id: 38,moduleType:'柱状图',isChart:true, name:'媒体类别分布',icon:'data2-icon',img:this.$imgHttp+'/yuqing_oem/yq_briefdoc_new/images/ptfb.jpg',chartId:'mediaLevelHistogram'},
            ],
            btNum : ['一','二','三','四','五','六','七','八','九'],
            cityList:[],
            tplInit:'',
            isShow:false,
            isActive:false,
            maxName:{'emotionEchart':0,'wordCloud':0,'mapEchart':0,'mapMentEchart':0}
        }
    },
    mounted() {
        let that = this;
        that.cityAjax();
		if(that.sid!=undefined){
            that.editAjax();
        }

    },
    beforeDestroy(){
        let that = this;
        that.previewBack();
    },
    methods: {
        // 红头文件开关
        oneButtonSwitch () {
            let that = this;
            that.status = (that.status == 0)?1:0;
        },
        cityAjax(){
            let that = this;
            that.$axios.get(this.$imgHttp+'/yuqing_oem/static/json/city.json').then(r=>{
                that.cityList = r.data.arrCity;
            }).catch(error =>{
                // console.log(error);
            });

        },
        choseCity(name, index,num){
            this.list1[index].province = name;
            this.list1[index].img = '/static/images/report/province/mapImg'+num+'.gif';
        },
        end (ev) {
            let that = this;
            that.list = [];
            that.maxName={'emotionEchart':0,'wordCloud':0,'mapEchart':0,'mapMentEchart':0};
            if(that.list1.length>0){
                that.list1.forEach((ele,index) => {
                    let tempArr = {};
                    if (ele.numId != undefined){console.log(ele.numId);
                        tempArr.numId = ele.numId;
                        that.maxName[ele.chartId]++;
                        ele.numId++;
                    }
                    tempArr.name = ele.name;
                    tempArr.img = ele.img;
                    tempArr.chartId = ele.chartId;
                    tempArr.isText = ele.isText;
                    tempArr.text = ele.text;
                    tempArr.showCity = ele.showCity;
                    tempArr.province = ele.province;
                    tempArr.maxId = ele.maxId;
                    tempArr.info = ele.info;
                    tempArr.isChart = ele.isChart;
                    tempArr.moduleType = ele.moduleType;
                    that.list.push(tempArr)
                });
                that.list1 = that.list;
                that.list1 = that.unique(that.list,'chartId');
            }
            if (ev.to.className === 'dragArea11') {
                //that.$set(that.list2[ev.oldIndex], 'flag', true)
            }
        },
        unique(arr, val) {
          const res = new Map()
          return arr.filter((item) => item.numId || !res.has(item[val]) && res.set(item[val], 1))
        },
        start22 (event) {
            this.falgs = '222222'
        },
        end22 (ev) {
            // console.log(this.list1);
            this.falgs = 'article'
        },
        handleDel (index, id ,chartId) {
            this.list1.splice(index, 1)
            let q = this.list2.find((value, index, arr) => {
                return value.id === id
            })
            //this.$set(q, 'flag', false)
        },
        //保存模板
        saveTemplete(){
            let that = this,tplHtml='',zlHtml='',rmHtml='',zlIndex=0,rmIndex=0,btIndex = 0,isHas1=false,isHas2 = false,isHas3 = false,has3Text='';

            if(that.tempform.tit == undefined || that.tempform.tit == ''){
                that.$utils.alertText('请填写报告标题',200);
                return;
            }
            if(that.list1.length ===0){
                that.$utils.alertText('请选择模块',200);
                return;
            }
            if(that.status===1 && (that.tempform.redFileTit == undefined || that.tempform.redFileTit == '')){
                that.$utils.alertText('请填写红头文件标题',200);
                return;
            }
            if(that.status===1 && (that.tempform.redFileName == undefined || that.tempform.redFileName == '')){
                that.$utils.alertText('请填写红头文件编号',200);
                return;
            }
            for(let item of this.list1){
                if(item.name == ''){
                    that.$utils.alertText('模块标题不能为空',200);
                    return;
                }
            }
            let data = {
                'openRedHeader':that.status,
                'redTitle':that.tempform.redFileTit,
                'redNumber':that.tempform.redFileName,
                'tplName':that.tempform.tit,
                'tplDesc':that.tempform.name,
                'tplCustom':that.list1,
                'tplInit':that.tplInit,
                'tplType':'2'
            };
            that.isActive = true;
            that.$parent.loadModal(true,'正在保存...');

            if(that.sid==undefined){
                that.$api.post('report/template/create',{data:data},r=>{
                    that.isActive = false;
                    that.$utils.returnCode(r,function(){
                        that.$parent.loadModal(false);
                        that.$utils.alertText('报告添加成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'报告添加成功！'})
                        if(that.isFromTiming){
                            that.$router.push({ path:'/analysis/addTimingTemplate',query:{id:that.timeId}})
                        }else{
                            that.$router.push({ path:'/analysis/ordinaryTemplate'})
                        }
                    });
                });
            }else{
                data.id = that.sid;
                that.$api.post('report/template/edit',{data:data},r=>{
                    that.isActive = false;
                    that.$utils.returnCode(r,function(){
                        that.$parent.loadModal(false);
                        that.$utils.alertText('报告修改成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'报告修改成功！'})
                        that.$router.push({ path:'/analysis/ordinaryTemplate'})
                    });
                });
            }
            that.previewBack();
        },
        //预览模板
        previewOpen(){
            this.isShow = true;
            $('body').addClass('finalDraft');
        },
        previewBack(){
            this.isShow = false;
            $('body').removeClass('finalDraft');
        },
        //编辑模板
        editAjax(){
            let that = this;
            that.$api.get('report/template/info',{id:that.sid},r=>{
                that.$utils.returnCode(r,function(){
                    that.status = parseInt(r.data.openRedHeader);
                    that.$set(that.tempform, 'redFileTit', r.data.redTitle);
                    that.$set(that.tempform, 'redFileName', r.data.redNumber);
                    that.$set(that.tempform, 'tit', r.data.tplName);
                    that.$set(that.tempform, 'name', r.data.tplDesc);
                    that.list1 = r.data.tplCustom;
                    that.list1.forEach((ele,index) => {
                        if (ele.numId != undefined){
                            that.maxName[ele.chartId] = ele.maxId;
                        }
                    });
                    that.list2.forEach((ele,index) => {
                        if (ele.numId != undefined){
                            ele.numId = that.maxName[ele.chartId];
                        }
                    });
                });
            });
        }
    },
}
</script>
<style >
    .temp-right{width:250px;bottom:34px;top:103px;position:fixed;right:50px}
    .finalDraft{background-color: rgba(0, 0, 0, 0.8);}
    .finalDraft .left-menu,.finalDraft .top-menu,.finalDraft .page-right{display: none}
    .finalDraft .right-div{top:0}
    .dragArea11 .name{border: none;font-size: 16px; width: 500px;padding: 5px;}
    .tnumber{
        width: 48px;height: 30px;background: url(../../../../static/images/ttbg.png) no-repeat;float: left;background-size: 100% 100%;
        text-align: center;line-height: 30px;color: #fff;font-size: 16px;
    }
</style>




// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/addNewOrdinaryTemplate.vue